import React from "react";
import Button from "./Button";
import Container from "./Container";
import Searchbar from "./Searchbar";
import { useReducer,useState,useEffect} from "react";
import { reducer,initialState } from "../reducers/reducers";
import Table1 from "./Table1";
import Dropdown from "./Dropdown";
import NewClaimTicket from "./NewClaimTicket"
import Confirm from "./Confirm";
import ViewClaim from "./ViewClaim";
import EditText from "./EditText";
import API_URLS from "../Urls";
import ViewProcess from "./ViewProcess";
import { useAuth } from "./AuthProvider";

const Process = () => {
    const { canWrite, canRead } = useAuth();
    const [fetchedNotes,setFetchedNotes] = useState([])
    const [viewData,setViewData] = useState({})
    const [searchOption, setSearchOption] = useState('')
    const [searchData,setSearchData] = useState('');
    // Estados para paginación
    const [page, setPage] = useState(1);
    const [perPage] = useState(15); // Fijo a 15 como en el backend
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [isSearching, setIsSearching] = useState(false);

    const postData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
    
    const search = () => {
        if (!searchData.trim()) {
            // Si el texto de búsqueda está vacío, no hacemos nada
            return;
        }
        
        // Verificar si el usuario tiene permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            // Limpiar datos existentes
            setFetchedNotes([]);
            setLastPage(1);
            setTotal(0);
            return;
        }
        
        setIsSearching(true);
        setPage(1); // Reiniciar a la primera página
        
        console.log(`Buscando por ${searchOption}: ${searchData}`);
        
        return fetch(API_URLS.CLAIM_TICKETS+`?${searchOption}=${searchData}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(data => {
            const dataArray = Array.isArray(data) ? data : (data.data ? data.data : []);
            console.log(`Resultados de búsqueda: ${dataArray.length} elementos`);
            
            setFetchedNotes(dataArray);
            
            // Aplicar paginación local a los resultados de búsqueda
            const calculatedLastPage = Math.ceil(dataArray.length / perPage) || 1;
            setLastPage(calculatedLastPage);
            setTotal(dataArray.length);
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setFetchedNotes([]);
            setLastPage(1);
            setTotal(0);
        });
    }
    
    // Función para limpiar la búsqueda
    const clearSearch = () => {
        setSearchData("");
        setIsSearching(false);
        setPage(1); // Reiniciar a la primera página
        fetchData(API_URLS.CLAIM_TICKETS); // Cargar datos normales
    }
    
    const fetchData =(url)=>{
        // Verificar si el usuario tiene permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            // Limpiar datos existentes
            setFetchedNotes([]);
            setLastPage(1);
            setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }
        
        // Agregar parámetros de paginación
        const paginatedUrl = `${url}?page=${page}&per_page=${perPage}`;
        console.log(`Solicitando datos: ${paginatedUrl}`);
        
        return fetch(paginatedUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(result => {
            // Si la respuesta es paginada
            if (result && result.data && result.page !== undefined) {
                console.log(`Respuesta paginada: ${result.data.length} elementos, página ${result.page} de ${result.last_page}, total: ${result.total}`);
                setFetchedNotes(result.data);
                setLastPage(result.last_page);
                setTotal(result.total);
            } else {
                // Respaldo para respuesta no paginada
                const dataArray = Array.isArray(result) ? result : [];
                console.log(`Respuesta no paginada: ${dataArray.length} elementos`);
                
                // Aplicar paginación local
                const startIndex = (page - 1) * perPage;
                const endIndex = Math.min(startIndex + perPage, dataArray.length);
                const paginatedData = dataArray.slice(startIndex, endIndex);
                
                console.log(`Aplicando paginación local: mostrando elementos ${startIndex+1}-${endIndex} de ${dataArray.length}`);
                
                setFetchedNotes(paginatedData);
                
                const calculatedLastPage = Math.ceil(dataArray.length / perPage) || 1;
                console.log(`Calculando paginación local: ${calculatedLastPage} páginas`);
                
                setLastPage(calculatedLastPage);
                setTotal(dataArray.length);
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setFetchedNotes([]);
            setLastPage(1);
            setTotal(0);
        });
    }
    
    useEffect(() => {
        if (!isSearching) {
            fetchData(API_URLS.CLAIM_TICKETS);
        }
    }, [page, isSearching]);

    // Controles de paginación
    function PaginationControls() {
        // Siempre mostrar controles, tanto para datos normales como para resultados de búsqueda
        
        // Estilos para los botones
        const buttonStyle = {
            backgroundColor: '#7AACE3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            margin: '0 5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
        };

        const disabledButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#cccccc',
            cursor: 'not-allowed',
            opacity: 0.7
        };
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
                <button 
                    onClick={() => setPage(prev => Math.max(prev - 1, 1))} 
                    disabled={page === 1}
                    style={page === 1 ? disabledButtonStyle : buttonStyle}
                >
                    &lt; Anterior
                </button>
                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                    Página {page} de {lastPage} ({total} registros)
                    {isSearching && ' - Resultados de búsqueda'}
                </span>
                <button 
                    onClick={() => setPage(prev => Math.min(prev + 1, lastPage))} 
                    disabled={page === lastPage}
                    style={page === lastPage ? disabledButtonStyle : buttonStyle}
                >
                    Siguiente &gt;
                </button>
            </div>
        );
    }

    
    const [state, dispatch] = useReducer(reducer, initialState);
    return(
        <div className="anylayout">
            <div className="titleFont">Proceso</div>
            <Container>
  <div className="invisible-horizontal-container">
    <div className="search-section">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          search();
        }}
        className="invisible-horizontal-container"
      >
        <div>Buscar por:</div>
        <Dropdown
          options={['id', 'idCliente', 'Nombre del cliente']}
          returnSelectedOption={(data) => {
            setSearchOption(data === 'Nombre del cliente' ? 'nombre' : data);
          }}
        />
        <EditText 
          text="Buscar..." 
          onChange={(data) => setSearchData(data)} 
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              search();
            }
          }}
        />
        <Button
          text="Buscar"
          color="#7AACE3"
          onClick={search}
        />
        {isSearching && (
          <Button 
            text="Limpiar búsqueda" 
            onClick={clearSearch} 
            color="#DF7476" 
          />
        )}
      </form>
    </div>
    
  </div>
</Container>
            {isSearching && (
                <div style={{ textAlign: 'center', margin: '10px 0', fontStyle: 'italic' }}>
                    Mostrando resultados de búsqueda para: "{searchData}" ({total} resultados)
                </div>
            )}
            <PaginationControls />
            <Table1 headers={['Id','Tipo','Facturar?','Cliente','Fecha','Observaciones','Cotizado','Sucursal','Causa','Reparado antes']} data={fetchedNotes} onClickView={(data)=>{console.log(data);setViewData(data);dispatch({type:'openViewProcess'})}} optview={true}></Table1>
            <PaginationControls />

            {state.statusViewProcess && (
                <ViewProcess claim={viewData} onClose={()=>{dispatch({type:'closeViewProcess'})}}></ViewProcess>)}
            
        </div>

    );
}
export default Process;